
export enum DisputeDrpCategoryCd {
	DRP_COLLECTIONS_ESCALATION = 'DRPCollectionsEscalation',
	DRP_DEBTOR_CHANGE = 'DRPDebtorChange',
	DRP_REGULAR = 'DRPRegular'}

